import ShowGasBrandMerchant from "./showGasBrandMerchant.js";
import {
  EditGasBrandMerchantFuel,
  EditGasBrandMerchantCoords,
  EditGasBrandMerchantInfo,
} from "./editGasBrandMerchant.js";
import CreateGasBrandMerchant from "./createGasBrandMerchant.js";

export default {
  ShowGasBrandMerchant,
  EditGasBrandMerchantFuel,
  EditGasBrandMerchantCoords,
  EditGasBrandMerchantInfo,
  CreateGasBrandMerchant,
};
